import { render, staticRenderFns } from "./InsCmsCat10.vue?vue&type=template&id=66fc75c2&scoped=true&"
import script from "./InsCmsCat10.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat10.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat10.vue?vue&type=style&index=0&id=66fc75c2&lang=less&scoped=true&"
import style1 from "./InsCmsCat10.vue?vue&type=style&index=1&id=66fc75c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc75c2",
  null
  
)

export default component.exports